import { createFileRoute } from '@tanstack/react-router';

export interface Search {
  locationId?: string;
  listType?: 'sent' | 'archived' | 'inbox';
  subCategory?: 'all' | 'completed' | 'needs-review' | 'retry-sync' | 'reviewed' | 'sync-manually';
  submissionId?: string;
}

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/submissions')({
  staticData: { team: 'forms' },
  validateSearch: (search: Search): Search => {
    return {
      locationId: search.locationId,
      listType: search.listType,
      subCategory: search.subCategory,
      submissionId: search.submissionId,
    };
  },
});
